import { rawLocationAtom, routerSelector } from "../state/router";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { CreateNewStack, ShowStacks } from "../state/stackAtoms";
import { strings } from "@quickpoint.me/shared";
import { useEffect } from "react";

/**
 * Reads desired path from routerSelector, mirrors it to rawLocationAtom
 * (→ browser history) and opens the "choose stack" panel when needed.
 */
export default function UrlManager() {
	const targetPath = useRecoilValue(routerSelector);
	const setRawLocation = useSetRecoilState(rawLocationAtom);
	const setShowStacks = useSetRecoilState(ShowStacks);
	const setCreateNewStack = useSetRecoilState(CreateNewStack);

	useEffect(() => {
		// write to atom → atom-effect pushes to history
		setRawLocation({ pathname: targetPath, search: "" });

		// side-effect for "/…/unset" route - open stacks panel with new
		// presentation input. Skipped when entering demo via URL: the tour
		// starts immediately and the panel would cover it.
		const enteringDemo =
			new URLSearchParams(window.location.search).get("enterDemo") === "true";
		if (targetPath.endsWith(`/${strings.unset}`) && !enteringDemo) {
			setShowStacks(true);
			setCreateNewStack(true);
		}
	}, [targetPath, setRawLocation, setShowStacks, setCreateNewStack]);

	return null;
}
